import { useRole } from "../../context/role/RoleContext";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { api } from "../../redux/apis/api";
import { FormDropDown } from "../form/dropdown";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import successToast from "../toast/successToast";
import errorToast from "../toast/errorToast";

const ShareModal = ({
  isOpen = false,
  onClose = () => {},
  selectID,
  moduleName = "",
  modulelabel = "",
  viewType = "page",
}) => {
  const { state } = useRole();
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const params = useParams();
  const [userList, setuserList] = useState([]);
  const [shareList, setShareList] = useState([]);
  const [selectedUser, setselectedUser] = useState("");

  console.log(state, "state");

  const initialValues = {
    ffadmin_id: selectedUser?.ffadmin_id ?? "",
    record_id:
      viewType === "page"
        ? params?.id
        : viewType === "modal"
        ? selectID
        : params?.id,
    module: selectedUser?.module ?? moduleName ?? "",
    read: selectedUser?.read ?? false,
    write: selectedUser?.write ?? false,
    access: selectedUser?.write ? "edit" : selectedUser?.read ? "view" : "",
  };

  const validationSchema = Yup.object().shape({
    module: Yup.string().required("Required"),
    record_id: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    const finalData = {
      ffadmin_id: values?.ffadmin_id ?? "",
      record_id: values?.record_id ?? "",
      module: values?.module ?? "",
      read:
        values?.access === "edit"
          ? true
          : values?.access === "view"
          ? true
          : false,
      write: values?.access === "edit" ? true : false,
    };

    api
      .post(`/record-assigned/create`, finalData)
      .then((response) => {
        successToast(response.message);
        onClose();
        setselectedUser("");
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchUserDropDownData = () => {
    api
      .get(`/ffadmin/user-list-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.users?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setuserList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchShareData = () => {
    const values = {
      record_id:
        viewType === "page"
          ? params?.id
          : viewType === "modal"
          ? selectID
          : params?.id,
      module: moduleName,
    };
    api
      .post(`/record-assigned/read`, values)
      .then((res) => {
        console.log(res?.data?.data?.rows);
        setShareList(res?.data?.data?.rows);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    if (isOpen) {
      fetchShareData();
      fetchUserDropDownData();
    }
  }, [isOpen]);

  const accessOptions = [
    { label: "Editor", value: "edit" },
    { label: "viewer", value: "view" },
  ];

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-lg w-full md:p-8 p-4 relative"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <h1 className="text-start text-lg md:text-xl font-fw_500 text-gray-800">
              Share {modulelabel}
            </h1>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Form>
                  <div>
                    <div className="w-full my-5">
                      <p>People with access</p>
                      <div className="flex justify-between items-center w-full px-2">
                        <div className="flex gap-3 items-center my-4">
                          <div className="w-[35px] h-[35px] rounded-full">
                            <img
                              src={state?.user?.profile_picture}
                              className="w-full h-full object-cover rounded-full"
                              alt="profile"
                            />
                          </div>
                          <h1 className="text-fs_16 font-fw_500">
                            {state?.user?.name}
                          </h1>
                        </div>
                        <div>
                          <label className="text-fs_14 text-lightText">
                            Owner
                          </label>
                        </div>
                      </div>

                      {shareList?.map((record, index) => (
                        <div className="flex justify-between items-center w-full px-2 relative">
                          <div className="flex gap-3 items-center my-4">
                            <div className="w-[35px] h-[35px] rounded-full">
                              <img
                                crossorigin="anonymous"
                                src={record?.ffAdminUser?.profile_picture}
                                className="w-full h-full object-cover rounded-full"
                              />
                            </div>
                            <h1 className="text-fs_16 font-fw_500">
                              {record?.ffAdminUser?.name}
                            </h1>
                          </div>
                          <div className="flex items-center gap-3">
                            <label className="text-fs_14 text-lightText">
                              {record?.write === true
                                ? "Editor"
                                : record?.read === true
                                ? "viewer"
                                : "--"}
                            </label>
                            <button
                              type="button"
                              onClick={() => setselectedUser(record)}
                              className="text-fs_14"
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="">
                      <p>Add user to get access</p>
                      <div className="mt-3">
                        <FormDropDown
                          name="ffadmin_id"
                          label="user"
                          options={userList}
                          value={userList?.find(
                            (item) => item?.value === values?.ffadmin_id
                          )}
                        />
                      </div>
                      <div className="w-full max-w-[200px]">
                        <FormDropDown
                          name="access"
                          label="access"
                          options={accessOptions}
                          value={accessOptions?.find(
                            (item) => item?.value === values?.access
                          )}
                        />
                      </div>
                    </div>
                    <div className="flex justify-between gap-5 mt-5">
                      <button
                        type="button"
                        onClick={onClose}
                        className="border border-primary text-primary text-base font-medium py-2 w-1/2 max-w-[14rem] rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="bg-primary text-white text-base font-medium py-2 w-1/2 max-w-[12rem] rounded-md"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default ShareModal;
